import publicApi from './publicApi';

const publicFormService = {
  async getBySlug(slug) {
    const response = await publicApi.get(`/forms/${slug}`);
    return response.data;
  },

  async submit(slug, answers) {
    const response = await publicApi.post(`/forms/${slug}/submit`, { answers });
    return response.data;
  },
};

export default publicFormService;
